import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import Layout from "../components/layout"
import ContactBox from "../components/contact-box"

const Services = () => {
  const page = "Hizmetler"
  const blogData = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "service" } } }
        sort: { fields: frontmatter___title }
      ) {
        edges {
          node {
            excerpt
            fields {
              slug
            }
            frontmatter {
              title
              featured {
                image
              }
            }
            html
          }
        }
      }
    }
  `)

  return (
    <Layout page={page}>
      <div className='wrapper pt-5'>
        <div className='grid'>
          {blogData.allMarkdownRemark.edges.map(edge => {
            return (
              <Link
                to={`/hizmetler/${edge.node.fields.slug}`}
                className='blogBox'
              >
                <div className='blogBoxImage'>
                  <img
                    src={edge.node.frontmatter.featured.image}
                    alt={edge.node.frontmatter.title}
                  />
                </div>
                <div className='blogBoxContent'>
                  <div className='blogBoxTitle'>
                    {edge.node.frontmatter.title}
                  </div>
                  <div className='blogBoxText'>{edge.node.excerpt}</div>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
      <ContactBox />
    </Layout>
  )
}

export default Services
